module.exports = __webpack_public_path__ + "img/4.3e4ce5cd.png";